
import { defineComponent, ref, onMounted } from "vue"
import { AutocallNumber } from "@/service/constant.json"

export default defineComponent({
  setup() {
    const isSpace = ref(false)
    onMounted(() => {
      setTimeout(() => {
        isSpace.value = true
      }, 20000)
    })
    return {
      AutocallNumber,
      isSpace,
    }
  },
})
